
const firebaseConfig = {
    apiKey: "AIzaSyCmoyPgpuF0eRqRvJLRyOtZ5lV5wd7TQrs",
    authDomain: "fooddelivery-616e1.firebaseapp.com",
    projectId: "fooddelivery-616e1",
    storageBucket: "fooddelivery-616e1.appspot.com",
    messagingSenderId: "162678017204",
    appId: "1:162678017204:web:860253de567563adfa9be1"
};

export default firebaseConfig